module.exports = __webpack_public_path__ + "static/media/verification.30125a40.svg";